import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import configProduction from './config/firebase.production'
import configDevelopment from './config/firebase.development'

firebase.initializeApp(process.env.REACT_APP_MODE === 'production' ? configProduction : configDevelopment)
export default firebase


// WEBPACK FOOTER //
// ./src/firebaseInit.js